import * as React from "react";
import { Box } from "@tiny/components";
import { SegmentCardProps } from "../PredefinedSegments.types";
import { CardName } from "./CardName";
import { CardDescription } from "./CardDescription";
import { usePredefinedSegmentsAccess } from "../PredefinedSegmentsAccess.hooks";

function SegmentCardDisabled({ name, description, index }: SegmentCardProps) {
  const { requestUpgradeForPredefinedSegments } = usePredefinedSegmentsAccess();
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      alignItems="flex-start"
      minWidth={150}
      flex="1 1 20%"
      p={4}
      border="1px solid"
      borderColor="grey.500"
      borderRadius="8px"
      bgcolor="inherit"
      onClick={requestUpgradeForPredefinedSegments}
    >
      <CardName name={name} disabled cardIndex={index} />
      <CardDescription description={description} disabled />
    </Box>
  );
}

export default SegmentCardDisabled;
